import React from "react";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
    return (
        <div style={{ minHeight: "auto" }}>
            <img src="images/org-img/sideimg.png" className="chngpassword-img" />
            <div id="circular-menu" className="circular-menu">
                <a className="floating-btn">
                    <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
                    <i aria-hidden="true" className="fa fa-times"></i>
                </a>
                <div className="items-wrapper">
                    <div className="menu-item is-flex">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-bell"
                        >
                            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                        </svg>
                    </div>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-bell"
                        >
                            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                        </svg>
                    </a>
                    <Link to="" className="menu-item is-flex">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-bell"
                        >
                            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                        </svg>
                    </Link>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="feather feather-grid"
                        >
                            <rect x="3" y="3" width="7" height="7"></rect>
                            <rect x="14" y="3" width="7" height="7"></rect>
                            <rect x="14" y="14" width="7" height="7"></rect>
                            <rect x="3" y="14" width="7" height="7"></rect>
                        </svg>
                    </a>
                </div>
            </div>
            <div className="container-fluid">
                <div className="row">
                    <div className="form-head d-flex flex-wrap align-items-center">
                        <div className="me-auto">
                            <img src="images/org-img/password.png" style={{ width: "17%" }} />
                            <h2 className="me-h2 font-w600 mb-0">
                                <b className="resetfont" style={{ marginRight: "10px" }}>Forgot</b> Password
                            </h2>
                            <p className="text-light">Lorem ipsum dolor sit amet</p>
                        </div>
                    </div>
                    <div className="">
                        <div className="row card-radius">
                            <div className="">
                                <div className="">
                                    <div className="chng-word">
                                        <div className="d-flex">
                                            <div className="left1">
                                                <div className="current-user">
                                                    <div className="">
                                                        <img
                                                            className="avatar is-squared w-100"
                                                            src="images/org-img/reset.svg"
                                                            data-demo-src="images/avatar/5.jpg"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="center1">
                                                <div className="form-group mb-4">
                                                    <h4 className="block-heading mb-3">Enter Password</h4>
                                                    <div className="form-group d-flex">
                                                        <input type="password" name="" className="form-control" />
                                                        <i className="fa fa-eye"></i>
                                                    </div>
                                                </div>
                                                <div className="form-group mb-4">
                                                    <h4 className="block-heading mb-3">Confirm Password</h4>
                                                    <div className="form-group d-flex">
                                                        <input type="password" name="" className="form-control" />
                                                        <i className="fa fa-eye"></i>
                                                    </div>
                                                </div>
                                                <Link to={"OTPVerification"}>
                                                    <button>Continue</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
